module.exports = __webpack_public_path__ + "static/media/medicine-pills.ef75e681.svg";